import { ConcreteEncodable } from "./ConcreteEncodable";

import { ForwardDetailsImplEncoder } from "../../encoder/ForwardDetailsImplEncoder";

import * as CubiqTS from "../../index";
import { ForwardDetails } from "../ForwardDetails";

export class ForwardDetailsImpl extends ConcreteEncodable implements ForwardDetails {
  public static enType: string = "com.bcdfx.model.event.lifecycle.fx.ForwardDetailsImpl";

  /*FID=100*/
  public messageId: string;
  /*FID=911*/
  public currentMktPts: CubiqTS.BigNumber | null = null;
  /*FID=912*/
  public currentMktPtsIndicativeFg: boolean;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ForwardDetailsImplEncoder.Instance;
    this.setEncodableType(ForwardDetailsImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ForwardDetailsImpl[" +
      "messageId=" +
      this.messageId +
      "currentMktPts=" +
      this.currentMktPts +
      "currentMktPtsIndicativeFg=" +
      this.currentMktPtsIndicativeFg +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
